import { SnippetType } from 'lib/const';
import React from 'react';
import { CovideoIcon } from 'lib/components/CovideoIcon';
import { FormikInputField } from 'lib/components/formik/FormikInputField';
import { useTheme } from 'styled-components/macro';
import { useFormikContext } from 'formik';
import { IQuickVideoForm } from 'lib/api/quickVideo/types';
import { Gap } from 'lib/components/styles/layout';
import {
  AddVariableButton,
  TextEditor,
} from 'lib/components/textEditorAutomotive';
import { useTranslation } from 'react-i18next';

const emailEditorToolbar = {
  options: [],
};

export const CustomizeEmailContent = () => {
  const { t } = useTranslation();
  const { values, setFieldValue, errors } = useFormikContext<IQuickVideoForm>();
  const theme = useTheme();
  return (
    <Gap width='100%' gap='5px'>
      <Gap
        gap='0'
        flexDirection='row'
        width='100%'
        flexWrap='nowrap'
        alignItems='baseline'
        style={{
          position: 'relative',
        }}
      >
        <FormikInputField
          name='emailContent.subject'
          isRequired={false}
          extendStyles={{
            mainWrapper: {
              flex: 1,
            },
            inputStyles: {
              padding: '0 130px 0 10px',
            },
          }}
        />
        <AddVariableButton
          extendStyles={{
            button: {
              border: 'transparent',
              borderRight: 'transparent',
              borderLeft: `1px solid ${theme.colors.neutral[20]}`,
              borderTopLeftRadius: 0,
              borderBottomLeftRadius: 0,
            },
            wrapper: {
              position: 'absolute',
              top: '1px',
              right: '1px',
            },
          }}
          dropdownButtonType='button'
          onTextChange={text => {
            setFieldValue(
              'emailContent.subject',
              `${values.emailContent.subject}${text}`
            );
          }}
        />
      </Gap>
      <TextEditor
        onTextEditorChange={text => {
          setFieldValue('emailContent.body', text);
        }}
        error={errors.emailContent?.body as string}
        toolbar={emailEditorToolbar}
        addVariableButtonType='button'
        initialContent={values.emailContent?.body}
        height='200px'
        showMagicButton
        magicBtnLabel={t('Script Assist')}
        snippetButtonPosition='inline'
        magicBtnMargin='0 0 0 8px'
        snippetType={SnippetType.Email}
        snippetButtonIcon={
          <CovideoIcon
            name='snippets'
            height={13}
            fill={theme.colors.secondary[100]}
          />
        }
        extendStyles={{
          wrapper: {
            width: '841px',
          },
          variableButton: {
            height: '40px',
            backgroundColor: theme.colors.white[100],
          },
          variableButtonContainer: {
            margin: '0 8px 0 auto',
          },
          snippetButtonVariant: 'white',
        }}
      />
    </Gap>
  );
};
